import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { CtaButton } from './ui/CtaButton';
const stack = [{
  item: '120 Ready-to-Teach Classes',
  primary: true
}, {
  item: '6 Professional Volumes',
  primary: true
}, {
  item: '5 Premium Bonus Guides'
}, {
  item: 'Instant Digital Access'
}];
export function OfferSection() {
  return <section id="offer" className="w-full bg-ivory py-10 sm:py-14 lg:py-20" aria-labelledby="offer-heading" data-id="element-89" data-mp="idzwv6fp9c5b">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-90" data-mp="md8redikde1x">
        <div className="mx-auto max-w-2xl text-center" data-id="element-91" data-mp="rdej1tou30k0">
          <div className="flex justify-center" data-id="element-92" data-mp="rbtow56fljmo">
            <SectionLabel data-id="element-93" data-mp="wd9du8bqcaac">The complete offer</SectionLabel>
          </div>
          <h2 id="offer-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-94" data-mp="2t5j9f0qoppsm">
            Everything you need to stop
            <span className="block text-forest" data-id="element-95" data-mp="12o1wb5cwh693">starting from a blank page.</span>
          </h2>
        </div>

        <div className="mt-6 overflow-hidden rounded-3xl border border-sandDark bg-cream shadow-card" data-id="element-96" data-mp="xwjrg67raliu">
          <ul className="grid gap-px bg-sandDark/60 sm:grid-cols-2" data-id="element-97" data-mp="syqorn5nw9nb">
            {stack.map(({
            item,
            primary
          }) => <li key={item} className="flex items-center justify-center gap-2.5 bg-cream px-4 py-3 text-center sm:px-6" data-id="element-98" data-mp="oxonl0s6pnip">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-forest" data-id="element-99" data-mp="1gn1im6cxx923">
                  <CheckIcon className="h-2.5 w-2.5 text-ivory" aria-hidden="true" data-id="element-100" data-mp="1ckn1bqox6hcx" />
                </span>
                <span className={`text-[0.88rem] leading-snug sm:text-[0.95rem] ${primary ? 'font-semibold text-ink' : 'text-muted'}`} data-id="element-101" data-mp="17ltlhrm5ue9l">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="border-t border-sandDark bg-ivory px-5 py-7 text-center sm:px-8" data-id="element-102" data-mp="3tvauq5fr3gdq">
            <p className="text-[0.6rem] font-semibold uppercase tracking-label text-clay" data-id="element-103" data-mp="2mdilzon5hzf">
              One-time purchase
            </p>
            <p className="mt-1 font-serif text-5xl font-semibold leading-none text-forest sm:text-6xl" data-id="element-104" data-mp="3kvnsjhf766jm">
              $27
            </p>
            <p className="mt-1.5 text-[0.62rem] font-semibold uppercase tracking-label text-muted" data-id="element-105" data-mp="3b38ayl7tbjz9">
              USD · No subscription
            </p>

            <div className="mt-5" data-id="element-106" data-mp="3fwb8t5jmhfl9">
              <CtaButton href="https://yogateachersystem.impultienda.ar/checkout" label="Get the complete Yoga Teacher System™" microcopy="Instant Digital Access • One-Time Purchase" data-id="element-107" data-mp="315u7dm6zmpod" />
            </div>

            <div className="mt-6 flex flex-col items-center gap-2 rounded-2xl border border-gold/30 bg-cream p-4 text-center" data-id="element-108" data-mp="2s6ql69cixu5n">
              <ShieldCheckIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-109" data-mp="2dhovj72d20b4" />
              <p className="max-w-sm text-[0.82rem] leading-snug text-muted" data-id="element-110" data-mp="28iu81rtg7nko">
                <span className="block font-serif text-[0.78rem] font-semibold uppercase tracking-label text-ink" data-id="element-111" data-mp="28kyfukugx6q8">
                  7-Day Satisfaction Guarantee
                </span>
                Explore the library for a full week. If it isn’t right for the way you teach, contact
                us within 7 days.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}